import { FC, useEffect } from 'react';
import {
  Container,
  Box,
  Checkbox
} from '@mui/material';
import PageGrid from 'components/PageGrid';
import AddIcon from '@mui/icons-material/Add';
import { observer } from "mobx-react"
import store from "./store"
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid';
import PopupGrid from 'components/PopupGrid';
import User_accountPopupForm from './../user_accountAddEditView/popupForm'
import styled from 'styled-components';
import CustomButton from 'components/Button';


type user_accountListViewProps = {
  idMain: number;
};


const User_accountListView: FC<user_accountListViewProps> = observer((props) => {
  const { t } = useTranslation();
  const translate = t;


  useEffect(() => {
    if (store.idMain !== props.idMain) {
      store.idMain = props.idMain
    }
    store.loaduser_accounts()
    return () => store.clearStore()
  }, [props.idMain])


  const columns: GridColDef[] = [
    {
      field: 'username',
      headerName: translate("label:user_accountListView.username"),
      flex: 1,
      renderCell: (param) => (<div data-testid="table_user_account_column_username"> {param.row.username} </div>),
      renderHeader: (param) => (<div data-testid="table_user_account_header_username">{param.colDef.headerName}</div>)
    },
    {
      field: 'full_name',
      headerName: translate("label:user_accountListView.full_name"),
      flex: 1.5,
      renderCell: (param) => (<div data-testid="table_user_account_column_full_name"> {param.row.full_name} </div>),
      renderHeader: (param) => (<div data-testid="table_user_account_header_full_name">{param.colDef.headerName}</div>)
    },
    {
      field: 'email',
      headerName: translate("label:user_accountListView.email"),
      flex: 1.5,
      renderCell: (param) => (<div data-testid="table_user_account_column_email"> {param.row.email} </div>),
      renderHeader: (param) => (<div data-testid="table_user_account_header_email">{param.colDef.headerName}</div>)
    },
    {
      field: 'position',
      headerName: translate("label:user_accountListView.position"),
      flex: 1,
      renderCell: (param) => (<div data-testid="table_user_account_column_position"> {param.row.position} </div>),
      renderHeader: (param) => (<div data-testid="table_user_account_header_position">{param.colDef.headerName}</div>)
    },
    {
      field: 'phone',
      headerName: translate("label:user_accountListView.phone"),
      flex: 1,
      renderCell: (param) => (<div data-testid="table_user_account_column_phone"> {param.row.phone} </div>),
      renderHeader: (param) => (<div data-testid="table_user_account_header_phone">{param.colDef.headerName}</div>)
    },
    // {
    //   field: 'has_signing_rights',
    //   headerName: translate("label:user_accountListView.has_signing_rights"),
    //   flex: 0.8,
    //   renderCell: (param) => (<div data-testid="table_user_account_column_has_signing_rights"> {<Checkbox checked={param.row.has_signing_rights} disabled />} </div>),
    //   renderHeader: (param) => (<div data-testid="table_user_account_header_has_signing_rights">{param.colDef.headerName}</div>)
    // },
    {
      field: 'is_active',
      headerName: translate("label:user_accountListView.is_active"),
      flex: 0.8,
      renderCell: (param) => (<div data-testid="table_user_account_column_is_active"> {<Checkbox checked={param.row.is_active} disabled />} </div>),
      renderHeader: (param) => (<div data-testid="table_user_account_header_is_active">{param.colDef.headerName}</div>)
    },
    {
      field: 'last_login',
      headerName: translate("label:user_accountListView.last_login"),
      flex: 1,
      renderCell: (param) => (
        <div data-testid="table_user_account_column_last_login">
          {param.row.last_login ? new Date(param.row.last_login).toLocaleString() : '-'}
        </div>
      ),
      renderHeader: (param) => (<div data-testid="table_user_account_header_last_login">{param.colDef.headerName}</div>)
    },
  ];

  let type1: string = 'popup';
  let component = null;
  switch (type1) {
    case 'form':
      component = <PageGrid
        title={translate("label:user_accountListView.entityTitle")}
        onDeleteClicked={(id: number) => store.deleteuser_account(id)}
        columns={columns}
        data={store.data}
        tableName="user_account" />
      break
    case 'popup':
      component = (
        <PopupGrid
          title={translate("label:user_accountListView.entityTitle")}
          onDeleteClicked={(id: number) => store.deleteuser_account(id)}
          onEditClicked={(id: number) => store.onEditClicked(id)}
          columns={columns}
          hideAddButton
          customBottom={
            <Box>
              <CustomButton
                variant='contained'
                sx={{ mb: 1 }}
                id={`user_accountAddButton`}
                onClick={() => store.onEditClicked(0)}
                endIcon={<AddIcon />}
              >
                {translate('add')}
              </CustomButton>
            </Box>
          }
          data={store.data}
          tableName="user_account"
        />
      );
      break
  }


  return (
    <Container maxWidth='xl' sx={{ mt: 4 }}>
      {component}

      <User_accountPopupForm
        openPanel={store.openPanel}
        id={store.currentId}
        onBtnCancelClick={() => store.closePanel()}
        onSaveClick={() => {
          store.closePanel()
          store.loaduser_accounts()
        }}
      />

    </Container>
  );
})



export default User_accountListView